import { useSearchParams, useParams } from "react-router-dom";
import { UploadCloud, FileText } from "lucide-react";
import { CvShell } from "@/components/cv/CvShell";
import { CvGate } from "@/components/cv/CvGate";
import { useAuth } from "@/context/AuthContext";
import { CV_DOC_GOALS } from "@/components/cv/cvContent";
import CvInterview from "./CvInterview";

const UploadPlaceholder = () => (
  <div data-testid="cv-upload-zone" className="max-w-2xl">
    <h2 className="font-display text-lg font-semibold text-brand-text">Dodaj swoje CV</h2>
    <div className="mt-4 flex flex-col items-center justify-center rounded-card border border-dashed border-brand-line bg-brand-bg px-6 py-12 text-center">
      <UploadCloud size={32} className="text-brand-accent" />
      <p className="mt-3 text-sm font-medium text-brand-text">Wgrywanie pliku PDF/DOCX dodamy w kolejnym etapie</p>
      <p className="mt-1 text-[13px] text-brand-muted">Odczyt istniejącego CV i potwierdzanie danych są w przygotowaniu.</p>
    </div>
    <p className="mt-4 text-[13px] text-brand-sec">Po odczycie potwierdzisz rozpoznane dane, a następnie wybierzesz cel:</p>
    <div className="mt-3 flex flex-wrap gap-2">
      {CV_DOC_GOALS.map((g) => <span key={g} className="rounded-full border border-brand-line px-3 py-1.5 text-[12.5px] text-brand-sec">{g}</span>)}
    </div>
  </div>
);

export default function CvCreator() {
  const [params] = useSearchParams();
  const { cvId } = useParams();
  const { user } = useAuth();
  const tryb = params.get("tryb") || "nowe";
  const returnTo = cvId ? `/cv/kreator/${cvId}` : `/cv/kreator?tryb=${tryb}`;

  return (
    <CvShell active="kreator">
      <div data-testid="cv-creator">
        {!user ? (
          <>
            <h1 className="font-display text-2xl font-semibold text-brand-text sm:text-3xl">Kreator CV</h1>
            <p className="mt-2 max-w-2xl text-brand-sec">
              Odpowiadasz na proste pytania własnymi słowami — resztę porządkujemy my. Nic nie dopisujemy bez Twojego potwierdzenia.
            </p>
            <div className="mt-6 flex items-start gap-2 text-[13px] text-brand-muted">
              <FileText size={14} className="mt-0.5" /> Podgląd struktury jest bezpłatny. Pełny wywiad ruszysz po założeniu konta.
            </div>
            <div className="mt-6 max-w-2xl"><CvGate returnTo={returnTo} /></div>
          </>
        ) : (tryb === "mam" && !cvId) ? (
          <>
            <h1 className="font-display text-2xl font-semibold text-brand-text sm:text-3xl">Mam już CV</h1>
            <p className="mt-2 max-w-2xl text-brand-sec">Prześlij dokument, a sprawdzimy jego zawartość i zaproponujemy dalsze działania.</p>
            <div className="mt-6"><UploadPlaceholder /></div>
          </>
        ) : (
          <CvInterview />
        )}
      </div>
    </CvShell>
  );
}
